import "./logo.css"

const Logo = () => {
	return (
		<div className="logo-container">
			<a href="https://www.rivalrymirror.com/l/token" target="_self" rel="noopener noreferrer">
				<img src="https://res.cloudinary.com/rivalry/image/upload/v1743707892/site/token/rivalry-full.svg" alt="Rivalry logo" className="logo" />
			</a>
		</div>
	)
}

export default Logo
